module.exports = __webpack_public_path__ + "static/img/banner-wrightin.0f592f10.png";